module.exports = __webpack_public_path__ + "static/img/20191008004.c73d471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/20191008004.jpg
// module id = y2v1
// module chunks = 45